import React from 'react'
import store from 'config/store/'
import { removeToken } from 'actions/tokenAction'
import Popup from 'components/shared/popup'

class WrongEmailMessage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      hide_component: true,
      entered_email: store.getState().email || ""
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleCloseByEsc, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleCloseByEsc, false);
  }

  handleCloseByEsc = (event) => {
    if (event.keyCode === 27) {
      this.handleCloseButton()
    }
  }

  handleOnClick = (event) => {
    event.preventDefault()
    this.setState({ hide_component: false })
  }

  handleCloseButton = () => {
    this.setState({ hide_component: true })
  }

  handleRemoveCookie = (event) => {
    event.preventDefault()
    store.dispatch(removeToken())
  }

  render() {

    return (
      <React.Fragment>
        <Popup hide_component={this.state.hide_component} handleCloseButton={this.handleCloseButton}>
          <h4>Keine E-Mail erhalten?</h4>
          <p>
            <strong>Prüfe Deinen Spam-Ordner</strong><br />
            Sollte die E-Mail nicht innerhalb einiger Minuten in Deinem Posteingang erscheinen, schaue bitte, ob sie fälschlicherweise im Ordner für „Spam“, Werbung oder „Junk-E-Mail“ gelandet ist.
          </p>
          <p className="margin-bottom-m">
            <strong>Hast Du Dich vertippt?</strong><br />
            Du hast Dich über die E-Mail-Adresse <span className="semibold">{this.state.entered_email}</span> angemeldet.
            Falls Du Dich vertippt haben solltest, kannst Du über folgenden <span style={{ cursor: 'pointer', textDecoration: 'underline' }} className="permalink semibold" onClick={this.handleRemoveCookie}>Link</span> erneut Deine E-Mail-Adresse eingeben.
          </p>
          <button className="secondary" onClick={this.handleCloseButton}>Schließen</button>
        </Popup>
        <a href="#!" className={this.props.classes} onClick={this.handleOnClick}>Keine E-Mail erhalten?</a>
      </React.Fragment>
    );
  }
}

WrongEmailMessage.defaultProps = {
  classes: 'font-size-xxs leading-ui14 font-bold'
}

export default WrongEmailMessage
